const settings = {
  settings: {
    transOil: {
      screens: [
        {
          title: 'x-label:workflow4.settings.hydraulic trans oil.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow4.settings.hydraulic trans oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow4.settings.hydraulic trans oil.hrs',
              num: '713.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow4.settings.hydraulic trans oil.screen2.hydraulic trans oil',
          data: [
            {
              label: 'x-label:workflow4.settings.hydraulic trans oil.screen2.use exmark premium transmission oil?',
              center: true,
              shrinkContent: true
            }
          ]
        },
        {
          title: 'x-label:workflow4.settings.hydraulic trans oil.screen3.reset trans oil maint hours',
          data: [
            {
              label: 'x-label:workflow4.settings.hydraulic trans oil.screen3.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/exit',
        right: 'settings/engine-oil'
      }
    },
    engineOil: {
      screens: [
        {
          title: 'x-label:workflow4.settings.engine oil.engine oil',
          data: [
            {
              label: 'x-label:workflow4.settings.engine oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow4.settings.engine oil.hrs',
              num: '313.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow4.settings.engine oil.screen2.engine oil',
          data: [
            {
              label: 'x-label:workflow4.settings.engine oil.screen2.use exmark premium oil api ck4?',
              center: true,
              shrinkContent: true
            }
          ]
        },
        {
          title: 'x-label:workflow4.settings.engine oil.screen3.reset engine oil maint hours',
          data: [
            {
              label: 'x-label:workflow4.settings.engine oil.screen3.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/hydraulic-trans-oil',
        right: 'settings/gearbox-oil'
      }
    },
    gearboxOil: {
      screens: [
        {
          title: 'x-label:workflow4.settings.deck gear box oil.deck gear box oil',
          data: [
            {
              label: 'x-label:workflow4.settings.deck gear box oil.maint hrs to service',
              center: true
            },
            {
              label: 'x-label:workflow4.settings.deck gear box oil.hrs',
              num: '313.2',
              invert: true,
              center: true
            }
          ]
        },
        {
          title: 'x-label:workflow4.settings.deck gear box oil.screen2.reset gear box oil',
          data: [
            {
              label: 'x-label:workflow4.settings.deck gear box oil.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-oil',
        right: 'settings/historical-error'
      }
    },
    historicalError: {
      screens: [
        {
          title: 'x-label:workflow4.settings.historical error.historical error',
          data: [
            {
              label: 'x-label:workflow4.settings.historical error.clutch output fault',
              center: true
            },
            {
              label: 'x-label:workflow4.settings.historical error.x',
              num: '2',
              center: true
            },
            {
              label: 'x-label:workflow4.settings.historical error.hrs',
              num: '150.4',
              center: true
            }
          ]
        }
      ],
      routes: {
        left: 'settings/gearbox-oil',
        right: 'settings/alarms'
      }
    },
    alarms: {
      screens: [
        {
          title: 'x-label:workflow4.settings.alarms.alarms',
          data: [
            {
              label: 'x-label:workflow4.settings.alarms.activate/deactivate',
            },
            {
              label: 'x-label:workflow4.settings.alarms.audible alarms',
            }
          ]
        }
      ],
      list: [
        {
          name: 'x-label:workflow4.settings.alarms.service air filter',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.service engine oil',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.service gearbox oil',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.service trans oil',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.system over voltage > 16v',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.system voltage low',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.system under voltage < 9v',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.clutch over current',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.clutch reset required',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.engine errors',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.anti stall active',
          active: true
        },
        {
          name: 'x-label:workflow4.settings.alarms.power up check',
          active: true
        }
      ],
      routes: {
        left: 'settings/historical-error',
        right: 'settings/engine-settings'
      }
    },
    engineSettings: {
      screens: [
        {
          title: 'x-label:workflow4.settings.engine settings.engine settings',
          data: [
            {
              label: 'x-label:workflow4.settings.engine settings.adjust engine speeds',
            }
          ]
        }
      ],
      list: [
        {
          name: 'lowMow',
          label: 'x-label:workflow4.settings.engine settings.set low mow speed',
          min: 1600,
          max: 2400,
          value: 1600
        },
        {
          name: 'effMow',
          label: 'x-label:workflow4.settings.engine settings.set eff mow speed',
          min: 2200,
          max: 2600,
          value: 2200
        },
        {
          name: 'maxMow',
          label: 'x-label:workflow4.settings.engine settings.set max mow speed',
          min: 2350,
          max: 2600,
          value: 2350
        },
        {
          name: 'effTrans',
          label: 'x-label:workflow4.settings.engine settings.set eff transport speed',
          min: 1550,
          max: 2000,
          value: 1550
        },
        {
          name: 'maxTrans',
          label: 'x-label:workflow4.settings.engine settings.set max transport speed',
          min: 2350,
          max: 2600,
          value: 2350
        }
      ],
      routes: {
        left: 'settings/alarms',
        right: 'settings/factory-defaults'
      }
    },
    factoryDefaults: {
      screens: [
        {
          title: 'x-label:workflow4.settings.factory defaults.factory defaults',
          data: [
            {
              label: 'x-label:workflow4.settings.factory defaults.reset',
            },
          ]
        },
        {
          title: 'x-label:workflow4.settings.factory defaults.screen2.factory defaults',
          data: [
            {
              label: 'x-label:workflow4.settings.factory defaults.screen2.are you sure?'
            }
          ]
        }
      ],
      routes: {
        left: 'settings/engine-settings',
        right: 'settings/exit'
      }
    },
    exit: {
      title: 'x-label:workflow4.settings.exit.exit',
      routes: {
        left: 'settings/factory-defaults',
        right: 'settings/hydraulic-trans-oil'
      }
    }
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/screens/data/flow4/settings.js